module.exports = __webpack_public_path__ + "static/media/logo-white.77e4f124.png";